export const chunkArrayHandler = (array, chunkSize) => {
  const chunkedArray = [];
  for (let i = 0; i < array.length; i += chunkSize) {
    const chunk = array.slice(i, i + chunkSize);
    chunkedArray.push(chunk);
  }
  return chunkedArray;
};

export const distributeElements = (list, numSubArrays) => {
  const result = Array.from({ length: numSubArrays }, () => []);

  list.forEach((item, index) => {
    result[index % numSubArrays].push(item);
  });

  return result;
};
